import { Component } from "react";

// Filet de sécurité : si un rendu plante quelque part dans l'app (React
// démonte alors tout #root par défaut, ne laissant que le fond de la page
// visible), on affiche un écran de récupération au lieu de rien du tout.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App crash caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 text-center bg-vanta-base">
          <div>
            <p className="text-white text-lg font-semibold mb-3">Un problème est survenu</p>
            <p className="text-white/50 text-sm mb-6">Veuillez recharger la page pour continuer.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl font-semibold"
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
